import { injectable } from 'inversify';
import { Observable, Subject, filter } from 'rxjs';
import { BrowserBroadcast, TabMessagesLabels, TabsEvent } from './browserBroadcast';

@injectable()
export class BroadcastChannelBrowserBroadcast implements BrowserBroadcast {
  private broadcastChannel: BroadcastChannel;
  private onMessage = new Subject<TabsEvent<TabMessagesLabels>>();

  constructor() {
    this.broadcastChannel = new BroadcastChannel('open_banking_browser_broadcast');
    this.broadcastChannel.onmessage = (message: MessageEvent<TabsEvent<TabMessagesLabels>>) => {
      this.onMessage.next(message.data);
      console.log('open_banking_browser_broadcast message received : ', message.data);
    };
  }

  publish(message: TabsEvent<TabMessagesLabels>): void {
    this.broadcastChannel.postMessage(message);
    console.log('open_banking_browser_broadcast message published : ', message);
  }

  getMessageFromLabel<TLabel extends TabMessagesLabels>(label: TLabel): Observable<TabsEvent<TLabel>> {
    return this.onMessage.pipe(filter((message) => message.label === label)) as Observable<TabsEvent<TLabel>>;
  }
}
